// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__sfpbC","requiredAsterisk":"Info_requiredAsterisk__oJYZ4"};